document.addEventListener('DOMContentLoaded', function () {
  initStickyBottomBanner();
  initLazyVideos();
});

function initStickyBottomBanner() {
  var page = document.querySelector('.adv-liam-page.has-sticky-bottom');
  var banner = document.getElementById('al-bottom-banner');

  if (!page || !banner) {
    return;
  }

  function measure() {
    page.style.paddingBottom = banner.offsetHeight + 'px';
  }

  measure();
  window.addEventListener('resize', measure);

  if (typeof ResizeObserver !== 'undefined') {
    var observer = new ResizeObserver(measure);
    observer.observe(banner);
  }
}

function initLazyVideos() {
  var videos = document.querySelectorAll('.adv-liam-page .al-device-video[data-src]');
  if (!videos.length) return;

  function activateVideo(video) {
    if (video.dataset.loaded === 'true') return;
    var src = video.getAttribute('data-src');
    if (!src) return;
    video.src = src;
    video.dataset.loaded = 'true';
    if (video.dataset.autoplay === 'true') {
      video.play().catch(function () {});
    }
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activateVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });

    videos.forEach(function (video) {
      observer.observe(video);
    });
    return;
  }

  videos.forEach(activateVideo);
}
